import { ChargeCategory } from 'constants/charges';
import { UnitSystem } from 'constants/units';
import { List, Map, Record, RecordOf } from 'immutable';
import {
  ChargeCalculator,
  DefaultCharge,
  DevicesType,
  FleetSettings,
  GroupType,
  Language,
  OdometerStrategy,
  Tax,
} from 'services/resources';

const defaultChargeDefaultValues: DefaultCharge = {
  autofill: false,
  category: ChargeCategory.OTHER,
  code: '',
  description: '',
  isDefaultCharge: false,
  name: '',
  overridable: false,
  id: 0,
  price: 0.0,
  quantityUnit: null,
  taxes: [],
  dealership: null,
};

export const defaultChargeFactory = Record(defaultChargeDefaultValues);

const settingsDefaultValues: FleetSettings = {
  allowTaxesPerAgreement: false,
  applyTaxes: false,
  availabilityBuffer: 0,
  batteryLow: null,
  chargeCalculator: ChargeCalculator.TRANSACTION,
  defaultDayOut: 0,
  defaultLanguage: Language.EN,
  enableGeofencing: false,
  forceVin: false,
  highRpmThreshold: 0,
  highSpeedThreshold: 0,
  hybridPaymentEntry: false,
  id: 0,
  turnBackMiles: 0,
  geofences: [],
  preferredOdometerStrategy: OdometerStrategy.REPORTED,
  stripeManagedCreditcards: false,
  twoSignatureEnabled: false,
  unitSystem: UnitSystem.METRIC,
  requireInsuranceOnAgreement: false,
  requireCreditCardOnAgreement: false,
  requireCheckoutSignature: false,
};

export const settingsFactory = Record(settingsDefaultValues);

type EmptyString = '';

export type AlertType = {
  id: number | null;
  turnBackMiles: number | EmptyString;
  highRpmThreshold: number | EmptyString;
  highSpeedThreshold: number | EmptyString;
  batteryLow: number | EmptyString;
  defaultDayOut: number | EmptyString;
};

export const alertFactory = Record<AlertType>({
  id: null,
  turnBackMiles: '',
  highRpmThreshold: '',
  highSpeedThreshold: '',
  batteryLow: '',
  defaultDayOut: '',
});

export const groupFactory = Record<GroupType>({
  id: null,
  dealership: null,
  name: null,
});

export const devicesFactory = Record<DevicesType>({
  id: null,
  imei: null,
  group: groupFactory(),
  vehicles: [],
  status: null,
  latestVin: null,
  lastUpdate: null,
  disabled: false,
});

type SettingsStateType = {
  alerts: RecordOf<AlertType>;
  charges: List<RecordOf<DefaultCharge>>;
  chargesErrors: object;
  defaultCharges: List<RecordOf<DefaultCharge>>;
  devices: List<RecordOf<DevicesType>>;
  taxes: List<RecordOf<Tax>>;
  termsAndConditions: object;
  settings: RecordOf<FleetSettings>;
  loading: boolean;
  errors: object;
  taxesErrors: Map<any, any>;
};

const settingsStateDefaultValues: SettingsStateType = {
  alerts: alertFactory(),
  charges: List<RecordOf<DefaultCharge>>(),
  chargesErrors: {},
  defaultCharges: List<RecordOf<DefaultCharge>>(),
  devices: List<RecordOf<DevicesType>>(),
  taxes: List<RecordOf<Tax>>(),
  termsAndConditions: {},
  settings: settingsFactory(),

  loading: false,

  errors: {},
  taxesErrors: Map({}),
};

export const settingsStateFactory = Record(settingsStateDefaultValues);
